module.exports = __webpack_public_path__ + "static/2007-boat-7018b1de72b1c65ede4777ad2d83c467.jpg";